var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products"},[(_vm.userExists)?_c('div',{staticClass:"products__button"},[_c('v-btn',{staticClass:"products__button--huge",attrs:{"color":"#f75007","dark":"","x-large":"","to":"/shop"}},[_vm._v(" "+_vm._s(_vm.$t("homepage.orderNow"))+" ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }